"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyType = void 0;
var KeyType;
(function (KeyType) {
    KeyType["albedo"] = "albedo";
    KeyType["ledger"] = "ledger";
    KeyType["freighter"] = "freighter";
    KeyType["plaintextKey"] = "plaintextKey";
    KeyType["trezor"] = "trezor";
})(KeyType || (exports.KeyType = KeyType = {}));
